import React from 'react';
import {useIntl} from 'react-intl';
import {Table} from 'web-components';
import Util from '../../../../forecast-app/shared/util/util';

const PeriodRow = ({data, resourceData, tableColumnProps, headerColumn, canExpandRow}) => {
	const intl = useIntl();
	const renderMinutes = minutes => {
		if (minutes) {
			return Util.convertMinutesToFullHour(minutes, intl);
		} else {
			return '–';
		}
	};

	const renderPercentage = percentage => {
		if (percentage) {
			return Util.getFormattedPercentage(percentage, intl);
		} else {
			return '–';
		}
	};

	return (
		<Table.Row {...tableColumnProps} canExpandRow={canExpandRow || !!data?.rows}>
			<Table.Column>{headerColumn}</Table.Column>
			{/* Actuals */}
			<Table.Column>{renderMinutes(resourceData.actualBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.actualNonBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.actualInternalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.actualTotalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.actualOverMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.actualBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.performance)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.actualNonBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.actualInternalUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.actualResourceUtilization)}</Table.Column>
			{/* Plan */}
			<Table.Column>{renderMinutes(resourceData.plannedBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.plannedNonBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.plannedInternalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.plannedTotalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.plannedOverMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.plannedBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.plannedNonBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.plannedInternalUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.plannedResourceUtilization)}</Table.Column>
			{/* Actuals vs. Plan */}
			<Table.Column>{renderMinutes(resourceData.billableActualVsPlan)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.nonBillableActualVsPlan)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.internalActualVsPlan)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.totalActualVsPlan)}</Table.Column>
			{/* Remaining */}
			<Table.Column>{renderMinutes(resourceData.remainingBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.remainingNonBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.remainingInternalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.remainingTotalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.remainingOverMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.remainingBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.remainingNonBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.remainingInternalMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.remainingResourceUtilization)}</Table.Column>
			{/* Forecast */}
			<Table.Column>{renderMinutes(resourceData.forecastBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.forecastNonBillableProjectMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.forecastInternalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.forecastTotalMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.forecastOverMinutes)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.forecastBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.forecastNonBillableUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.forecastInternalUtilization)}</Table.Column>
			<Table.Column>{renderPercentage(resourceData.forecastResourceUtilization)}</Table.Column>
			{/* Availability */}
			<Table.Column>{renderMinutes(resourceData.workingMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.timeOffMinutes)}</Table.Column>
			<Table.Column>{renderMinutes(resourceData.availableMinutes)}</Table.Column>
		</Table.Row>
	);
};

export default PeriodRow;
